const TOAST_NOTIFICATIONS_LIMIT = 3 as const;

export { TOAST_NOTIFICATIONS_LIMIT };
